import { EnumerationBuilder } from 'utility-js-enumeration';
export const CourseKeyEnum = EnumerationBuilder.useDefinitionAsEnum('CourseKeyEnum', {
  ID: 'key',
  TITLE: '<span class="text text-sz-l ">What do these colors mean?</span>',
  ELEMENTS: {
    DESC: {
      template:
        '<p class="text text-sz-l ">Each course has a status. Below explains what each color means.</p>' +
        '<hr class="mvl">' +
        '{{statusList}}'
    }
  }
} as any);
angular.module('capability-ng-academic-planner').constant('CourseKeyEnum', CourseKeyEnum);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/types/course_key_enum.ts